import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Heading,
  ChevronRightIcon,
  Center,
  Pressable,
} from 'native-base';
import {IHistoryDetail} from '../../../../../../interfaces/dtos';
import {BolivarIcon, DollarIcon} from '../../../../../../components/icons';
import {
  WaitingIcon,
  ApprovedIcon,
  RejectedIcon,
} from '../../../../../../components/icons';
import {HistoryStatus} from '../../../../../../constants/enumerations';

interface CustomProps {
  onPress: () => void;
  rowType: 'odd' | 'even';
}

type ItemProps = CustomProps & Omit<IHistoryDetail, 'order'>;

const HistoryItem = (props: ItemProps) => {
  const {id, status, amount, onPress, rowType, bank, account} = props;

  const handleOnPress = () => {
    onPress();
  };

  const getStripedColor = () => {
    if (rowType === 'odd') {
      return '#FFFFFF';
    }
    return '#F8F8F8';
  };

  const getBankLabel = () => {
    return `${bank}-${account.substring(account.length - 4)}`;
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack
        width="100%"
        backgroundColor={getStripedColor()}
        paddingY={3}
        paddingX={5}>
        <VStack flex={1}>
          <HStack space={5}>
            <VStack justifyContent="center" space="0" flex={1} marginLeft={1}>
              <Box height="5" justifyContent="center">
                <Heading size="sm" fontWeight="16" color="#4C4C4C">
                  {id}
                </Heading>
              </Box>
              <Box height="5" justifyContent="center" marginTop={1}>
                <Text
                  color="#99A2B4"
                  fontSize={'12'}
                  ellipsizeMode="tail"
                  numberOfLines={1}>
                  {getBankLabel()}
                </Text>
              </Box>
            </VStack>
            <HStack w="160" alignItems="center">
              <Box marginRight={2}>
                {status.id === HistoryStatus.waiting && (
                  <WaitingIcon size={22} />
                )}
                {status.id === HistoryStatus.approved && (
                  <ApprovedIcon size={22} />
                )}
                {status.id >= HistoryStatus.rejected && (
                  <RejectedIcon size={22} />
                )}
              </Box>

              {amount.foreign && <DollarIcon />}
              {amount.local && <BolivarIcon />}
              <Box height="5" alignItems={'flex-end'} paddingLeft="2" flex={1}>
                <Text fontWeight="bold" color="#06355E">
                  {amount.foreign ? amount.foreign : amount.local}
                </Text>
              </Box>
            </HStack>
          </HStack>
        </VStack>
        <Box>
          <Center flex={1} paddingLeft={2}>
            <ChevronRightIcon size="5" color="blue.500" />
          </Center>
        </Box>
      </HStack>
    </Pressable>
  );
};

export default HistoryItem;
